import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Github, MessageCircle, ArrowRight } from 'lucide-react';
import { BrandLink } from './BrandLogo';

const SECTIONS = [
    {
        title: 'Product Matrix',
        links: [
            { label: 'Meta Ads Manager', href: '/dashboard/crm/marketing/meta-manager' },
            { label: 'WA Business API', href: '/dashboard/messages' },
            { label: 'CRM Pipeline board', href: '/dashboard/crm/pipeline' },
            { label: 'Campaign Builder', href: '/dashboard/crm/marketing/campaigns' },
        ]
    },
    {
        title: 'Operational Unit',
        links: [
            { label: 'Core Features', href: '#features' },
            { label: 'Pricing Protocols', href: '#pricing' },
            { label: 'Developer Gateway', href: '/api-docs' },
            { label: 'Contact Support', href: '/support' },
        ]
    },
    {
        title: 'Governance',
        links: [
            { label: 'Terms of Service', href: '/terms' },
            { label: 'Privacy Protocol', href: '/privacy' },
            { label: 'Cookie Registry', href: '#' },
            { label: 'GDPR Compliance', href: '#' },
        ]
    }
];

const WebsiteFooter = () => {
    return (
        <footer className="bg-white text-[var(--slds-color-text-main)] pt-24 pb-12 font-sans border-t border-[var(--slds-color-border)]">
            <div className="w-full px-6 lg:px-20">


                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-12 lg:gap-20 mb-20">
                    
                    {/* Brand Info (Aligned Left) */}
                    <div className="flex flex-col space-y-8 lg:col-span-1">
                        <BrandLink to="/" size={40} subtitle="AI Revenue Command" />
                        <p className="text-[14px] font-medium text-[var(--slds-color-text-secondary)] leading-relaxed">
                            AI CRM and marketing automation platform for WhatsApp Business messaging, Meta Ads management, pipeline visibility, and customer engagement analytics.
                        </p>
                        <div className="flex items-center gap-4">
                            {[Facebook, Twitter, Linkedin, Github].map((Icon, i) => (
                                <a key={i} href="#" className="w-8 h-8 rounded-[var(--slds-radius)] bg-[var(--slds-color-bg)] flex items-center justify-center text-[var(--slds-color-text-secondary)] hover:text-[var(--slds-color-brand)] hover:bg-[var(--slds-color-brand)]/10 transition-all border border-[var(--slds-color-border)]">
                                    <Icon size={14} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Matrices (All Aligned with Logo horizontally in grid) */}
                    {SECTIONS.map((section, i) => (
                        <div key={i} className="flex flex-col space-y-8">
                            <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[var(--slds-color-text-secondary)] border-b border-[var(--slds-color-border)] pb-2">
                                {section.title}
                            </h4>
                            <ul className="space-y-4">
                                {section.links.map((link, j) => (
                                    <li key={j}>
                                        <a href={link.href} className="text-[13px] font-semibold text-[var(--slds-color-text-secondary)] hover:text-[var(--slds-color-brand)] transition-colors inline-flex items-center gap-2 group">
                                            {link.label} <ArrowRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom Bar (Aligned Left) */}
                <div className="pt-10 border-t border-[var(--slds-color-border)] flex flex-col md:flex-row items-center justify-between gap-8">
                    <div className="flex flex-col md:flex-row items-center gap-6 text-[11px] font-bold text-[var(--slds-color-text-secondary)]">
                        <span>&copy; {new Date().getFullYear()} WaapLeads Platform Operations.</span>
                        <div className="flex items-center gap-4">
                            <Link to="/status" className="hover:text-[var(--slds-color-brand)] transition-colors">System: Operational</Link>
                            <span className="opacity-20">|</span>
                            <span>Region: Global (v4.2)</span>
                        </div>
                    </div>
                    <div className="text-[11px] font-bold text-[var(--slds-color-text-secondary)]">
                        Certified by <a href="#" className="text-[var(--slds-color-brand)] border-b border-[var(--slds-color-brand)]/20 hover:border-[var(--slds-color-brand)] transition-all">WaapLeads Engineering</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default WebsiteFooter;
